import React from 'react';
/**
 * @ignore - internal component.
 */

var Tablelvl2Context = React.createContext();
export default Tablelvl2Context;